import CreditCardRow from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/CreditCardsList/CreditCardRow/CreditCardRow';

export default CreditCardRow;
